import core from '@/helpers/client'

const hybridCategoryService = {
  async headHybridCategoryAsync(params) {
    const result = await core.head(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/HybridCategories`,
      params
    )
    return result
  },
  async headMappingHybridCategoryAsync(params) {
    const result = await core.head(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/HybridCategories/checkmappinghybrid`,
      params
    )
    return result
  },
  async getHybridCategoryListAsync(params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/HybridCategories`,
      params
    )
    return result
  },
  async getHybridCategorySearchListByIdsAsync(model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/HybridCategories/listbyids`,
      model
    )
    return result
  },
  async getHybridCategoryTreeNodeAsync() {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/HybridCategories/treenode`
    )
    return result
  },
  async getMappingHybridCategoryTreeNodeAsync(params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/HybridCategories/mappingtreenode`,
      params
    )
    return result
  },
  async getHybridCategoryDetailAsync(id, params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/HybridCategories/${id}`,
      params
    )
    return result
  },
  async anyChildHybridCategoryDetailAsync(id) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/HybridCategories/${id}/children`
    )
    return result
  },
  async getStatusParentHybridCategoryAsync(parentId) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/HybridCategories/parents/${parentId}/status`
    )
    return result
  },
  async getHybridProductSkuListAsync(id) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/HybridCategories/${id}/skus`
    )
    return result
  },
  async createHybridCategoryAsync(model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/HybridCategories`,
      model
    )
    return result
  },
  async updateHybridCategoryAsync(id, model) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/HybridCategories/${id}`,
      model
    )
    return result
  },
  async updateAllHybridApprovalAsync(id, model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/HybridCategories/${id}/approval`,
      model
    )
    return result
  },
  async deleteHybridCategoryByIdAsync(id) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/HybridCategories/delete/${id}`
    )
    return result
  },
  async deleteHybridCategoryMappedAsync(id, model) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/HybridCategories/deletecategorymapped/${id}`,
      model
    )
    return result
  },
}
export default hybridCategoryService
